import { useState, type CSSProperties } from "react";
import { Eye, EyeOff } from "lucide-react";
import { T } from "../tokens";

interface Props {
  value:        string;
  onChange:     (v: string) => void;
  placeholder?: string;
  autoComplete?: string;
  required?:    boolean;
  style?:       CSSProperties;   // applied to the <input> (matches the caller's field styling)
}

/**
 * A password input with a show/hide (eye) toggle. The type flips between
 * "password" and "text" locally; the toggle never leaves the field's own state,
 * so parents keep a plain (value, onChange) contract. Used on signup + signin
 * (and the Profile change-password form).
 */
export function PasswordField({ value, onChange, placeholder, autoComplete, required, style }: Props) {
  const [show, setShow] = useState(false);

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <input
        type={show ? "text" : "password"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
        required={required}
        style={{ ...style, paddingRight: "40px" }}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        aria-pressed={show}
        tabIndex={-1}
        style={{
          position: "absolute", top: 0, right: 0, height: "100%", width: "38px",
          display: "flex", alignItems: "center", justifyContent: "center",
          background: "none", border: "none", cursor: "pointer", color: T.t2,
        }}
      >
        {show ? <EyeOff size={15} strokeWidth={1.8}/> : <Eye size={15} strokeWidth={1.8}/>}
      </button>
    </div>
  );
}
